"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "confirmation-content text-left flex-column" };
const _hoisted_2 = {
    key: 0,
    class: "confirmation-section flex-column"
};
const _hoisted_3 = { class: "flex-gap flex-column" };
const _hoisted_4 = { class: "confirmation-section flex-column" };
const _hoisted_5 = { class: "confirmation-instructions font-sm m-0" };
const _hoisted_6 = { class: "confirmation-section flex-column" };
const _hoisted_7 = { class: "font-sm m-0" };
const _hoisted_8 = { class: "confirmation-section flex-column" };
const _hoisted_9 = { class: "font-sm m-0" };
const models_1 = require("../../../../js/models");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIConfirmation',
    props: {
        selectedRoles: {
            type: Array,
            default: () => [],
        },
        showRoles: {
            type: Boolean,
            default: false,
        },
        instructions: {
            type: String,
            default: '',
        },
        sendSkills: {
            type: Boolean,
            default: false,
        },
        sendODays: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        const props = __props;
        function roleStyle(role) {
            if (!role.color || role.color === models_1.OPLUS_COLOR_PALETTE.DEFAULT || role.color === 'none') {
                return;
            }
            return {
                backgroundColor: `#${role.color}`,
                color: '#fff',
            };
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("p", { class: "m-0" }, " 以下の条件を確認してから続行してください。AIシフトの作成を開始するとキャンセルできず、完了まで数分かかる場合があります。 ", -1 /* CACHED */)),
                (__props.showRoles && __props.selectedRoles.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_2, [
                        _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("div", null, "業務", -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.selectedRoles, (role) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                    key: role.getOriginalId(),
                                    class: "role-name selected-role",
                                    style: (0, vue_2.normalizeStyle)(roleStyle(role))
                                }, (0, vue_2.toDisplayString)(role.getName()), 5 /* TEXT, STYLE */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createElementVNode)("section", _hoisted_4, [
                    _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("div", null, "シフト作成条件", -1 /* CACHED */)),
                    (0, vue_2.createElementVNode)("p", _hoisted_5, (0, vue_2.toDisplayString)(__props.instructions.trim() || 'なし'), 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("section", _hoisted_6, [
                    _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("div", null, "シフト作成時にスキルを考慮する", -1 /* CACHED */)),
                    (0, vue_2.createElementVNode)("p", _hoisted_7, (0, vue_2.toDisplayString)(__props.sendSkills ? 'はい' : 'いいえ'), 1 /* TEXT */)
                ]),
                (0, vue_2.createElementVNode)("section", _hoisted_8, [
                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("div", null, "「○」が提出された日に優先して割り当てる", -1 /* CACHED */)),
                    (0, vue_2.createElementVNode)("p", _hoisted_9, (0, vue_2.toDisplayString)(__props.sendODays ? 'はい' : 'いいえ'), 1 /* TEXT */)
                ])
            ]));
        };
    }
});
